import React from 'react'
import { connect } from 'react-redux'

const UserInfo = (props) => {
  if (!props.user) {
    return (
      <div className='empty'>
        <div className='empty-icon'>
          <i className='icon icon-people' />
        </div>
        <p className='empty-title h5'>Please login to view user information</p>
      </div>
    )
  }

  return (
    <div className='inner-container'>
      <h2>User information</h2>
      <table className='table fs-exclude'>
        <tbody>
          <tr>
            <td>token_type</td>
            <td>{props.user.token_type}</td>
          </tr>
          <tr>
            <td>access_token</td>
            <td><input type="text" defaultValue={props.user.access_token} id="myInput"></input>
            </td>
          </tr>
          <tr>
            <td>expires_at</td>
            <td>{props.user.expires_at}</td>
          </tr>
          <tr>
            <td>scope</td>
            <td>{props.user.scope}</td>
          </tr>
          {Object.keys(props.user.profile).map(key => (
            <tr key={key}>
              <td>{key}</td>
              <td>{props.user.profile[key]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function mapStateToProps (state) {
  return {
    user: state.oidc.user
  }
}

export default connect(
  mapStateToProps,
  null
)(UserInfo)
